import React from "react";

const social = [
  {
    href: "https://www.linkedin.com/company/rt-jobspot-digital-media/",
    label: "LinkedIn",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-9h3v9zm-1.5-10.271c-.966 0-1.75-.785-1.75-1.75s.784-1.75 1.75-1.75 1.75.785 1.75 1.75-.784 1.75-1.75 1.75zm13.5 10.271h-3v-4.604c0-1.1-.021-2.51-1.531-2.51-1.531 0-1.769 1.196-1.769 2.429v4.685h-3v-9h2.882v1.229h.041c.4-.756 1.379-1.555 2.838-1.555 3.036 0 3.597 2.001 3.597 4.599v4.727z" />
      </svg>
    ),
  },
  {
    href: "https://t.me/rtjobspot",
    label: "Telegram",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12 0c-6.627 0-12 5.373-12 12 0 6.627 5.373 12 12 12s12-5.373 12-12c0-6.627-5.373-12-12-12zm5.93 7.765l-1.812 8.555c-.137.607-.497.757-1.008.472l-2.786-2.055-1.344 1.294c-.148.148-.273.273-.56.273l.201-2.849 5.182-4.678c.226-.201-.049-.314-.352-.113l-6.407 4.029-2.193-.685c-.477-.149-.487-.477.099-.701l8.555-3.302c.403-.148.757.099.627.688z" />
      </svg>
    ),
  },
  {
    href: "https://wa.me/+917887260088",
    label: "WhatsApp",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M20.52 3.48A11.815 11.815 0 0012 0C5.373 0 0 5.373 0 12c0 2.11.55 4.08 1.52 5.82L0 24l6.36-1.66A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12 0-3.2-1.25-6.2-3.48-8.52zm-8.52 16.2a9.9 9.9 0 01-5.34-1.56l-.38-.23-3.78 1 1-3.7-.25-.38a9.9 9.9 0 01-1.56-5.34c0-5.52 4.48-10 10-10 2.66 0 5.16 1.04 7.04 2.92a9.9 9.9 0 012.92 7.04c0 5.52-4.48 10-10 10zm5.46-7.14c-.3-.15-1.76-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.18.2-.36.22-.66.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.48-1.77-1.65-2.07-.17-.3-.02-.46.13-.61.14-.14.3-.36.45-.54.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.87 1.22 3.07.15.2 2.1 3.2 5.1 4.49.71.31 1.26.5 1.69.64.71.23 1.36.2 1.87.12.57-.1 1.76-.72 2.01-1.42.25-.7.25-1.3.18-1.42-.07-.12-.27-.2-.57-.35z" />
      </svg>
    ),
  },
];

const Footer = () => (
  <footer className="bg-slate-950 py-8 text-center text-white">
    <div className="mb-4 flex justify-center space-x-5">
      {social.map((s, idx) => (
        <a
          key={idx}
          href={s.href}
          aria-label={s.label}
          target="_blank"
          rel="noopener noreferrer"
          className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/5 text-lg transition hover:-translate-y-1 hover:bg-secondary hover:text-slate-950 focus:outline-none"
        >
          {s.icon}
        </a>
      ))}
    </div>
    <p className="text-sm tracking-[0.12em] text-slate-300 uppercase">RT Jobspot</p>
    <p className="mt-2 text-sm text-slate-400">&copy; {new Date().getFullYear()} All rights reserved.</p>
  </footer>
);

export default Footer;
